export const omit = <T extends object, K extends keyof T>(
    object: T,
    predicate: string | number | (string | number)[] | ((value: T[K]) => boolean),
): T => {
    if (typeof predicate === 'function') {
        return Object.keys(object).reduce(
            (acc, key) => (predicate(object[key as K]) ? acc : { ...acc, [key]: object[key as K] }),
            {} as T,
        );
    }

    const omitKeys = Array.isArray(predicate) ? predicate : [predicate];

    return Object.keys(object).reduce(
        (acc, key) => (omitKeys.includes(key) ? acc : { ...acc, [key]: object[key as K] }),
        {} as T,
    );
};
